import { render, staticRenderFns } from "./EditSpaceDefaultLanguage.vue?vue&type=template&id=17e88cf9"
import script from "./EditSpaceDefaultLanguage.vue?vue&type=script&lang=js"
export * from "./EditSpaceDefaultLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports